import { ClassRoomType, SpeakingClassLevel } from "../gql/graphql.ts";
import { RemainingLessonInfoBag } from "./RemainingLessonInfoBag.tsx";

export enum ExtendedClassRoomType {
  Exam = "Exam",
  SpeakingClass = "SpeakingClass",
  OneOnOne = "OneOnOne",
}

export type CalendarCardComponentProps = {
  title: string;
  startDateUtc: string;
  level: SpeakingClassLevel;
  participantsCount: number;
  capacity: number;
  meetUri?: string;
  pdfUrl?: string;
  type: ClassRoomType | ExtendedClassRoomType;
  ctaLabel: string;
  ctaAction: () => Promise<void>;
  loadingCta?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  hideCta?: boolean;
  remainingLessonInfo?: RemainingLessonInfoBag;
  showLessonTopicBadge?: boolean;
  showModal: boolean;
  onClose: () => void;
  onOpen: () => void;
  slotTimezone: string;
};
